  document.addEventListener('DOMContentLoaded', function () {
    var articleBody = document.getElementById('ArticleBody');
    var tocWrapper = document.getElementById('ArticleTOCWrapper');
    var tocList = document.getElementById('ArticleTOCList');
    var tocDetails = document.getElementById('ArticleTOCDetails');
    var progressBar = document.getElementById('ArticleProgressBar');
    var copyButtons = document.querySelectorAll('[data-copy-link]');
    var copyStatus = document.getElementById('CopyLinkStatus');
    var copyStatusTop = document.getElementById('CopyLinkStatusTop');
    var copyFeedback = document.getElementById('CopyLinkFeedback');
    var copyFeedbackTop = document.getElementById('CopyLinkFeedbackTop');

    if (articleBody && tocWrapper && tocList) {
      var headings = articleBody.querySelectorAll('h2, h3');
      var items = [];
      var usedIds = {};
      var currentH2Id = null;

      headings.forEach(function (heading, index) {
        var text = heading.textContent.trim();
        if (!text) return;

        var level = heading.tagName.toLowerCase();
        var baseId = text
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-');

        if (!baseId) {
          baseId = 'section-' + index;
        }

        var existingId = heading.getAttribute('id');
        var finalId = existingId && !usedIds[existingId] ? existingId : baseId;
        var counter = 2;

        while (
          usedIds[finalId] ||
          (
            document.getElementById(finalId) &&
            document.getElementById(finalId) !== heading
          )
        ) {
          finalId = baseId + '-' + counter;
          counter++;
        }

        usedIds[finalId] = true;
        heading.id = finalId;

        if (level === 'h2') {
          currentH2Id = heading.id;
        }

        items.push({
          id: heading.id,
          text: text,
          level: level,
          parentId: level === 'h3' ? currentH2Id : null
        });
      });

      var hasH2 = items.some(function (item) {
        return item.level === 'h2';
      });

      if (items.length >= 2 && hasH2) {
        tocWrapper.hidden = false;

        var topLevelItems = [];
        var itemMap = {};

        items.forEach(function (item) {
          itemMap[item.id] = item;

          if (item.level === 'h2') {
            item.children = [];
            topLevelItems.push(item);
          } else if (item.level === 'h3' && item.parentId && itemMap[item.parentId]) {
            itemMap[item.parentId].children.push(item);
          }
        });

        topLevelItems.forEach(function (item) {
          var li = document.createElement('li');
          li.className = 'article-toc__item article-toc__item--h2';
          li.setAttribute('data-id', item.id);

          var a = document.createElement('a');
          a.className = 'article-toc__link';
          a.href = '#' + item.id;
          a.textContent = item.text;
          li.appendChild(a);

          if (item.children && item.children.length) {
            var subList = document.createElement('ol');
            subList.className = 'article-toc__sublist';

            item.children.forEach(function (child) {
              var childLi = document.createElement('li');
              childLi.className = 'article-toc__item article-toc__item--h3';
              childLi.setAttribute('data-id', child.id);

              var childA = document.createElement('a');
              childA.className = 'article-toc__link';
              childA.href = '#' + child.id;
              childA.textContent = child.text;

              childLi.appendChild(childA);
              subList.appendChild(childLi);
            });

            li.appendChild(subList);
          }

          tocList.appendChild(li);
        });

        var tocLinks = tocList.querySelectorAll('.article-toc__link');
        var observedHeadings = items
          .map(function (item) { return document.getElementById(item.id); })
          .filter(Boolean);

        var clearReadingState = function () {
          observedHeadings.forEach(function (heading) {
            heading.classList.remove('is-reading');
          });
        };

        var setActiveLink = function (id) {
          var activeItem = itemMap[id];
          if (!activeItem) return;

          var activeH2Id = activeItem.level === 'h2' ? activeItem.id : activeItem.parentId;

          tocList.querySelectorAll('.article-toc__item--h2').forEach(function (h2Item) {
            var isExpanded = h2Item.getAttribute('data-id') === activeH2Id;
            h2Item.classList.toggle('is-expanded', isExpanded);
          });

          tocLinks.forEach(function (link) {
            var hrefId = link.getAttribute('href').replace('#', '');
            var isExactActive = hrefId === id;
            var isParentActive =
              activeItem.level === 'h3' &&
              hrefId === activeH2Id &&
              itemMap[hrefId] &&
              itemMap[hrefId].level === 'h2';

            var isActive = isExactActive || isParentActive;

            link.classList.toggle('is-active', isActive);

            if (isActive) {
              link.setAttribute('aria-current', hrefId === id ? 'true' : 'location');
            } else {
              link.removeAttribute('aria-current');
            }
          });

          clearReadingState();

          var activeHeading = document.getElementById(id);
          if (activeHeading) {
            activeHeading.classList.add('is-reading');
          }

          if (activeItem.level === 'h3' && activeH2Id) {
            var parentHeading = document.getElementById(activeH2Id);
            if (parentHeading) {
              parentHeading.classList.add('is-reading');
            }
          }

          var activeLink = tocList.querySelector('.article-toc__link[href="#' + id + '"]');
          if (activeLink) {
            var tocContainer = tocList.closest('.article-toc__nav');

            if (tocContainer && window.innerWidth > 767) {
              var containerRect = tocContainer.getBoundingClientRect();
              var linkRect = activeLink.getBoundingClientRect();

              if (linkRect.top < containerRect.top || linkRect.bottom > containerRect.bottom) {
                tocContainer.scrollTo({
                  top: tocContainer.scrollTop + (linkRect.top - containerRect.top) - 24,
                  behavior: 'auto'
                });
              }
            }
          }
        };

        var suppressObserverUntil = 0;

        if ('IntersectionObserver' in window && observedHeadings.length) {
          var observer = new IntersectionObserver(function (entries) {
            if (Date.now() < suppressObserverUntil) return;

            var visibleEntries = entries.filter(function (entry) {
              return entry.isIntersecting;
            });

            if (visibleEntries.length) {
              visibleEntries.sort(function (a, b) {
                return a.boundingClientRect.top - b.boundingClientRect.top;
              });

              setActiveLink(visibleEntries[0].target.id);
            }
          }, {
            rootMargin: '-5% 0px -80% 0px',
            threshold: 0.01
          });

          observedHeadings.forEach(function (heading) {
            observer.observe(heading);
          });
        }

        tocList.addEventListener('click', function (event) {
          var link = event.target.closest('a');
          if (!link) return;

          var hash = link.getAttribute('href');
          if (!hash) return;

          var targetId = hash.slice(1);
          var target = document.getElementById(targetId);
          if (!target) return;

          event.preventDefault();

          var offset = 96;
          var targetTop = target.getBoundingClientRect().top + window.scrollY - offset;

          suppressObserverUntil = Date.now() + 1000;
          setActiveLink(targetId);

          window.scrollTo({
            top: targetTop,
            behavior: 'smooth'
          });

          history.replaceState(null, '', hash);

          if (window.innerWidth <= 767 && tocDetails) {
            tocDetails.removeAttribute('open');
          }
        });
      } else {
        tocWrapper.hidden = true;
      }
    }

    var updateProgress = function () {
      if (!progressBar || !articleBody) return;

      var rect = articleBody.getBoundingClientRect();
      var bodyTop = window.scrollY + rect.top;
      var bodyHeight = articleBody.offsetHeight;
      var viewportHeight = window.innerHeight;
      var scrollY = window.scrollY;

      var progress = ((scrollY - bodyTop + viewportHeight * 0.2) / bodyHeight) * 100;
      progress = Math.max(0, Math.min(100, progress));
      progressBar.style.width = progress + '%';
    };

    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);

    var showCopiedFeedback = function () {
      [copyFeedback, copyFeedbackTop].forEach(function (node) {
        if (!node) return;

        node.hidden = false;

        requestAnimationFrame(function () {
          node.classList.add('is-visible');
        });

        clearTimeout(node._hideTimer);

        node._hideTimer = setTimeout(function () {
          node.classList.remove('is-visible');

          clearTimeout(node._hiddenTimer);
          node._hiddenTimer = setTimeout(function () {
            node.hidden = true;
          }, 220);
        }, 1600);
      });
    };

    copyButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-copy-link');
        if (!url) return;

        navigator.clipboard.writeText(url).then(function () {
          if (copyStatus) copyStatus.textContent = 'Article link copied to clipboard.';
          if (copyStatusTop) copyStatusTop.textContent = 'Article link copied to clipboard.';
          showCopiedFeedback();
        }).catch(function () {
          if (copyStatus) copyStatus.textContent = 'Unable to copy the link.';
          if (copyStatusTop) copyStatusTop.textContent = 'Unable to copy the link.';
        });
      });
    });

    var syncTocDetailsState = function () {
      if (!tocDetails) return;

      if (window.innerWidth <= 767) {
        tocDetails.removeAttribute('open');
      } else {
        tocDetails.setAttribute('open', 'open');
      }
    };

    syncTocDetailsState();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncTocDetailsState, 120);
    });
  });